export default __webpack_public_path__ + "static/media/pscHand.9dc99cec.png";